import React from 'react';
import { Typography, Stack, Divider } from '@mui/material';

import type { BulkRequestProps } from '../../models';
import { fDateTime } from '../../utils/formatTime';

interface AssessmentDetailProps {
	assessmentDates: BulkRequestProps['prefAssessmentDates'] | BulkRequestProps['assessmentDates'];
	location: string;
	dateLineText: string;
}

export const AssessmentDetail = ({ assessmentDates, location, dateLineText }: AssessmentDetailProps) => {
	return (
		<Stack spacing={1}>
			<Typography>
				<strong>Address:</strong> {location}
			</Typography>
			{assessmentDates?.map((date, index) => {
				if (!date) return null;

				return (
					// biome-ignore lint/suspicious/noArrayIndexKey: display only not modify items
					<React.Fragment key={index}>
						<Divider sx={{ my: 2 }} />
						<Typography>
							<strong>
								{index + 1}
								{['st', 'nd', 'rd'][index] ?? 'th'} {dateLineText} Date:
							</strong>{' '}
							{fDateTime(date)}
						</Typography>
					</React.Fragment>
				);
			})}
		</Stack>
	);
};
